var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4373 22.2109C45.2523 21.3959 46.5737 21.3959 47.3887 22.2109C48.1528 22.9749 48.2006 24.1841 47.532 25.0038L47.3887 25.1623L28.2583 44.2927C27.4942 45.0568 26.2851 45.1045 25.4654 44.436L25.3069 44.2927L16.6113 35.597C15.7962 34.782 15.7962 33.4607 16.6113 32.6456C17.3753 31.8816 18.5845 31.8338 19.4042 32.5024L19.5627 32.6456L26.7826 39.866L44.4373 22.2109Z",
    fill: "#146EB4",
    stroke: "#146EB4",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/confirmation-icon.a26ba7395497e5a8677c958d8553a107.svg";
export { ForwardRef as ReactComponent };